export default [
  {
    path: '/logistics/transport',
    name: 'LogisticTransportList',
    component: () => import('@/views/Logistic/LogisticTransportList.vue')
  },
  {
    path: '/logistics/transport/:id',
    name: 'LogisticTransportUpdate',
    component: () => import('@/views/Logistic/LogisticTransportUpdate.vue'),
    redirect: {
      name: 'LogisticTransportUpdate_fuel'
    },
    children: [
      {
        path: 'fuel',
        name: 'LogisticTransportUpdate_fuel',
        component: () => import('@/components/logistic/LogisticTransportUpdate_fuel.vue')
      },
      {
        path: 'rent',
        name: 'LogisticTransportUpdate_rent',
        component: () => import('@/components/logistic/LogisticTransportUpdate_rent.vue')
      },
      {
        path: 'driver',
        name: 'LogisticTransportUpdate_driver',
        component: () => import('@/components/logistic/LogisticTransportUpdate_driver.vue')
      }
    ]
  }
]
